<template>
  <div v-show="isOpen">
    <div
      class="modal fade in"
      style="display: block;"
      tabindex="-1"
      role="dialog"
      @click="closeModal"
      ref="modal"
      @keydown.esc="closeModal"
    >
      <div
        class="modal-dialog"
        role="document"
        :style="`width: ${width}; max-width: calc(100% - 20px)`"
        @keydown.esc="closeModal"
      >
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <slot name="header">
              <button
                v-if="!hideCloseBtn"
                type="button"
                class="close"
                aria-label="Close"
                @click="closeModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">{{ title }}</h4>
            </slot>
          </div>
          <div v-if="!hideBody" class="modal-body">
            <slot v-if="isOpen"></slot>
          </div>
          <div class="modal-footer h-tac">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in" @click="closeModal" />
  </div>
</template>

<script>
export default {
  name: 'BaseModal',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '600px',
    },
    hideBody: {
      type: Boolean,
      default: false,
    },
    hideCloseBtn: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    document.addEventListener('keydown', this.onKeyDown);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  },

  watch: {
    async isOpen(value) {
      if (value) {
        // Makes it so content beneath modal is not scrollable by hiding overflow.
        // This removes the scrollbar, so we adjust the body width to avoid content "jumping"
        const oldWidth = document.body.clientWidth;
        document.body.classList.add('modal-open');
        document.body.style.width = `${oldWidth}px`;
        this.$refs.modal.focus();
      } else {
        document.body.classList.remove('modal-open');
        document.body.style.width = 'auto';
      }
    },
  },

  methods: {
    onKeyDown(e) {
      // escape was pressed
      if (e.keyCode === 27) {
        this.closeModal();
      }
    },

    closeModal() {
      this.$emit('close');
    },
  },
};
</script>
